import { Observable } from 'rxjs';

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EventManager } from '@angular/platform-browser';

interface Options {
  element: any;
  keys: string;
  excludeTargetNames: string[];
}

/** @dynamic */
@Injectable()
export class HotkeysService {
  private defaults: Partial<Options> = {
    element: this.document
  };

  constructor(private eventManager: EventManager, @Inject(DOCUMENT) private document: Document) { }

  addShortcut(options: Partial<Options>): Observable<KeyboardEvent> {
    const merged = { ...this.defaults, ...options };
    const event = `keydown.${merged.keys}`;

    return new Observable(observer => {
      const handler = (e: KeyboardEvent) => {
        if (!merged.excludeTargetNames || !merged.excludeTargetNames.map(x => x.toLowerCase())
          .includes((e.target as HTMLElement).tagName.toLowerCase())) {
          e.preventDefault();
          observer.next(e);
        }
      };

      const dispose = this.eventManager.addEventListener(
        merged.element, event, handler
      );

      return () => {
        dispose();
      };
    });
  }
}
